import { DataTable } from "@msuite/ui/table";
import { useCalculationMembers } from "@/hooks/use-calculation-members";
import type { CalculationPanelBaseProps } from "../shared";
import { columns } from "./table-config";

export function CalculationMembers({ calculationId }: CalculationPanelBaseProps) {
	/** Hooks */
	const { members, isLoading, queryKey, refetch } = useCalculationMembers(calculationId);

	/** Render */
	return (
		<DataTable
			data={members}
			columns={columns}
			persistenceKey="calculation-members-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
		/>
	);
}
